import { TableCell, Tooltip } from '@mui/material';
import PropTypes from 'prop-types';

import JobStatus from './JobStatus';

const JobStatusCell = ({ status, error }) => {
  return (
    <TableCell>
      {status && (
        <Tooltip placement="right" title={error || ''}>
          <JobStatus status={status} />
        </Tooltip>
      )}
    </TableCell>
  );
};

JobStatusCell.propTypes = {
  status: PropTypes.string,
  error: PropTypes.string,
};

export default JobStatusCell;
